import ImageInspectorPanelSelector from '../ImageInspectorPanelSelector';
import { UploadType } from '../../../../../hooks/useUploader';
import { useCardWidgetMutations } from '../../../../../mutations/widgets/card';
import { CVAsset, CVFile, CardWidget } from '../../../../../types';
import { getAssetUrl } from '../../../../../constants/widgets';
import { useActiveWidget } from '../../../../../queries/guides';
import { useInspectorStore } from '../../../../../stores/inspectorStore';

const CardImageSelector = () => {
  const activeWidget = useActiveWidget() as CardWidget;
  const widgetSettings = useInspectorStore(s => s.widgetSettings);
  const card = activeWidget?.cards[widgetSettings?.widgetIndex];
  const { addAsset, removeAsset, uploadAssetInCard } = useCardWidgetMutations();
  const handleAssetSelect = (selectedMedia: CVAsset[], file: CVFile) => {
    const {
      databaseId,
      name,
      url: imageAssetUrl,
      extensions,
      derivatives,
    } = selectedMedia[0];

    addAsset.mutate({
      cardId: card.id,
      cardIndex: widgetSettings?.widgetIndex,
      asset: {
        id: databaseId,
        name: name,
        detailUrl: imageAssetUrl,
        imageUrl: getAssetUrl(extensions[0], file, derivatives.webImage),
        extension: extensions[0],
      },
    });
  };

  const handleCropSet = (croppedUrl: string) => {
    addAsset.mutate({
      cardId: card.id,
      cardIndex: widgetSettings?.widgetIndex,
      asset: {
        id: card.asset.id,
        name: card.asset.name,
        detailUrl: card.asset.detailUrl,
        imageUrl: croppedUrl,
        extension: card.asset.extension,
      },
    });
  };

  const handleUploadCompleted = (mediaId: string) => {
    uploadAssetInCard.mutate({
      mediaId,
      cardId: card.id,
      cardIndex: widgetSettings?.widgetIndex,
    });
  };

  const handleRemoveAsset = () => {
    removeAsset.mutate({
      cardId: card.id,
      cardIndex: widgetSettings?.widgetIndex,
    });
  };
  return (
    <ImageInspectorPanelSelector
      uploadType={UploadType.Card}
      handleUploadCompleted={handleUploadCompleted}
      handleAssetSelect={handleAssetSelect}
      handleOnClearImage={handleRemoveAsset}
      handleOnSetImage={handleCropSet}
      imageUrl={card?.asset.imageUrl}
      assetName={card?.asset.name}
    />
  );
};

export default CardImageSelector;
